import { formatUnits } from 'viem';

import { publicClient } from 'lib/web3/client';

/** Transparent proxy that delegates to GenisisMint (DSC_MINT_PRICE lives in implementation storage). */
const DEFAULT_DSC_MINT_PRICE_PROXY = '0x5d19305298341445dd928566451abfab50645286' as const;

const dscMintPriceAbi = [
  {
    type: 'function',
    name: 'DSC_MINT_PRICE',
    inputs: [],
    outputs: [{ name: 'price', type: 'uint256' }],
    stateMutability: 'view',
  },
] as const;

function proxyAddress(): `0x${ string }` {
  const fromEnv = typeof process !== 'undefined' ? process.env.NEXT_PUBLIC_DSC_MINT_PRICE_PROXY : undefined;
  return (fromEnv && fromEnv.startsWith('0x') ? fromEnv : DEFAULT_DSC_MINT_PRICE_PROXY) as `0x${ string }`;
}

/**
 * Reads DSC_MINT_PRICE() on the configured proxy and returns the value in DSC units (÷ 1e18).
 * Used for header “mint price” display when CMC/native USD is unavailable.
 */
export async function readDscMintPriceNative(): Promise<number | null> {
  if (!publicClient) {
    return null;
  }

  try {
    const address = proxyAddress();
    const wei = await publicClient.readContract({
      address,
      abi: dscMintPriceAbi,
      functionName: 'DSC_MINT_PRICE',
    });
    const s = formatUnits(wei, 18);
    const n = Number(s);
    return Number.isFinite(n) && n >= 0 ? n : null;
  } catch {
    return null;
  }
}
